import { useEffect, useState } from 'react';

type CookiebotConsentCategory = 'preferences' | 'statistics';

const hasConsent = (category: CookiebotConsentCategory): boolean =>
  window.Cookiebot?.consent?.[category] === true;

const useCookiebotConsent = (category: CookiebotConsentCategory): boolean => {
  const [hasCookiebotConsent, setHasCookiebotConsent] = useState(() =>
    hasConsent(category),
  );

  useEffect(() => {
    const updateConsent = (): void =>
      setHasCookiebotConsent(hasConsent(category));

    updateConsent();
    window.addEventListener('CookiebotOnAccept', updateConsent);
    window.addEventListener('CookiebotOnDecline', updateConsent);

    return (): void => {
      window.removeEventListener('CookiebotOnAccept', updateConsent);
      window.removeEventListener('CookiebotOnDecline', updateConsent);
    };
  }, [category]);

  return hasCookiebotConsent;
};

export default useCookiebotConsent;
